import React, { useEffect, useState } from 'react';
import styles from "./profile.module.css"
import { MdOutlineAddAPhoto, MdOutlineCheck, MdOutlineClose, MdOutlineEdit, MdOutlineMailLock, MdOutlinePublishedWithChanges } from 'react-icons/md';
import { BsPersonGear } from 'react-icons/bs';
import ImageWithFallback from './../../components/ImageWithFallback';
import FormGroup from './../../components/Form/FormGroup';
import FormGroupInline from '../../components/Form/FormGroupInline';
import Input from '../../components/Form/Input';
import Button from '../../components/Form/Button';
import { useAuth } from '../../contexts/authContext';
import api from '../../services/api';
import { toast } from 'react-toastify';
import ModalChangePassword from '../../components/Modal/ModalChangePassword';
import ModalChangeEmail from '../../components/Modal/ModalChangeEmail';
import { openSelectSingleFile } from '../../utils/utils';

const defaultProfilePictureSvg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" role="img" aria-label="Usuario sem foto">
  <defs>
    <linearGradient id="background" x1="24" y1="18" x2="136" y2="142" gradientUnits="userSpaceOnUse">
      <stop stop-color="#fff7fb"/>
      <stop offset="0.55" stop-color="#f3edff"/>
      <stop offset="1" stop-color="#eaf7ff"/>
    </linearGradient>
    <linearGradient id="accent" x1="52" y1="40" x2="108" y2="130" gradientUnits="userSpaceOnUse">
      <stop stop-color="#ff5aa5"/>
      <stop offset="1" stop-color="#7c3aed"/>
    </linearGradient>
    <filter id="shadow" x="18" y="20" width="124" height="126" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feDropShadow dx="0" dy="8" stdDeviation="8" flood-color="#4c1d95" flood-opacity="0.15"/>
    </filter>
  </defs>
  <rect width="160" height="160" rx="22" fill="url(#background)"/>
  <circle cx="126" cy="34" r="18" fill="#ffffff" opacity="0.72"/>
  <circle cx="34" cy="128" r="24" fill="#ffffff" opacity="0.55"/>
  <g filter="url(#shadow)">
    <circle cx="80" cy="62" r="30" fill="#ffffff"/>
    <path d="M32 132c4.8-28.4 24.7-44 48-44s43.2 15.6 48 44c-13.3 10-29.9 16-48 16s-34.7-6-48-16Z" fill="#ffffff"/>
  </g>
  <circle cx="80" cy="62" r="24" fill="url(#accent)" opacity="0.9"/>
  <path d="M45 130c6.2-20.8 19.1-31.4 35-31.4s28.8 10.6 35 31.4c-9.8 6.4-21.8 10-35 10s-25.2-3.6-35-10Z" fill="url(#accent)" opacity="0.9"/>
</svg>
`

const defaultProfilePicture = `data:image/svg+xml;utf8,${encodeURIComponent(defaultProfilePictureSvg)}`

const Profile = () => {
    const [name, setName] = useState("")
    const [image, setImage] = useState()
    const [showModalChangePassword, setShowModalChangePassword] = useState(false)
    const [showModalChangeEmail, setShowModalChangeEmail] = useState(false)
    const [editable, setEditable] = useState(false)
    const [waitCode, setWaitCode] = useState(false)
    const [showOptionsEditImage, setShowOptionsEditImage] = useState(false)
    const { user, updateNameUser, updateEmailUser, updateImageUser, account } = useAuth()

    useEffect(() => {
        if (user?.name) {
            setName(user.name)
        }
    }, [user])

    const onCancelEditname = () => {
        setEditable(false)
        setName(user?.name)
    }

    const onChangeName = () => {
        api.patch(`/users/profile`, { name }).then(response => {
            setEditable(false)
            updateNameUser(name)
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        })
    }

    const onChangePassword = (e, user) => {
        e.preventDefault()
        api.patch(`/users/changePassword`, user).then(response => {
            setShowModalChangePassword(false)
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        })
    }

    const onChangeEmail = (e, data) => {
        e.preventDefault()
        const url = waitCode ? `/users/changeEmail/validate` : `/users/changeEmail`
        api.patch(url, data).then(response => {
            if (waitCode) {
                const newEmail = response?.data?.data || "-"
                updateEmailUser(newEmail)
                setShowModalChangeEmail(false)
                setWaitCode(false)
            } else {
                setWaitCode(true)
            }
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        })
    }

    const onReturnChange = (e) => {
        e.preventDefault()
        setWaitCode(false)
    }

    const handleToogleShowOptionsImage = () => {
        setShowOptionsEditImage(previousValue => !previousValue)
    }

    const handleUpdateImage = () => {
        const formData = new FormData()
        formData.append("image", image)
        api.patch("users/changeImage", formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
            const newLinkImage = response?.data?.data
            updateImageUser(newLinkImage)
            setImage(undefined)
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        })
    }

    const handleDeleteImage = () => {
        api.delete("users/changeImage").then(response => {
            updateImageUser(undefined)
            setImage(undefined)
            toast.success(response?.data?.message)
        }).catch(err => {
            toast.error(err?.response?.data?.message)
        })
    }

    const handleCancelChangeImage = () => {
        setImage(null)
    }

    return (
        <div className={styles.content}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <BsPersonGear />
                    <span>Perfil</span>
                </div>
                <div className={styles.body}>
                    <div className={styles.groupImage}>
                        <div className={styles.image}>
                            <ImageWithFallback
                                src={image ? URL.createObjectURL(image) : (user?.image || defaultProfilePicture)}
                                alt="Imagem de Perfil"
                                functionError={() => <img src={defaultProfilePicture} alt="Imagem de Perfil" />}
                            />
                            {image ?
                                <>
                                    <FormGroupInline>
                                        <div className={`${styles.changeImage} ${styles.confirm}`}>
                                            <div className={`${styles.actionButton} ${styles.confirmAction}`} onClick={handleUpdateImage}>
                                                <MdOutlineCheck />
                                            </div>
                                            <div className={`${styles.actionButton} ${styles.cancelAction}`} onClick={handleCancelChangeImage}>
                                                <MdOutlineClose />
                                            </div>
                                        </div>
                                    </FormGroupInline>
                                </>
                                :
                                <div className={styles.changeImage} onClick={handleToogleShowOptionsImage}>
                                    <div className={styles.actionButton}>
                                        <MdOutlineAddAPhoto />
                                    </div>
                                    {showOptionsEditImage &&
                                        <>
                                            <ul>
                                                <li onClick={() => openSelectSingleFile(setImage, "image/*")}>
                                                    Editar
                                                </li>
                                                <li onClick={handleDeleteImage}>Remover</li>
                                            </ul>
                                            <div className={styles.background} />
                                        </>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <FormGroupInline >
                        <FormGroup labelText="Nome">
                            {editable ?
                                <Input placeholder="Nome" value={name || ""} onChange={(e) => setName(e.target.value)} theme="noBorder" />
                                :
                                <span>{user?.name}</span>
                            }
                        </FormGroup>
                        {editable ?
                            <>
                                <MdOutlineCheck onClick={() => onChangeName()} />
                                <MdOutlineClose onClick={() => onCancelEditname()} />
                            </>
                            :
                            <MdOutlineEdit onClick={() => setEditable(true)} />
                        }
                    </FormGroupInline>
                    <FormGroup labelText="E-mail">
                        <span>{user.email || "-"}</span>
                    </FormGroup>
                    <FormGroup labelText="Conta atual">
                        <span>{account?.name || "-"}</span>
                    </FormGroup>
                </div>
                <div className={styles.footer}>
                    <Button variant="primary" onClick={() => setShowModalChangeEmail(true)}>
                        <FormGroupInline>
                            Alterar e-mail
                            <MdOutlineMailLock />
                        </FormGroupInline>
                    </Button>
                    <Button variant="accent" onClick={() => setShowModalChangePassword(true)}>
                        <FormGroupInline>
                            <span>Alterar senha</span>
                            <MdOutlinePublishedWithChanges />
                        </FormGroupInline>
                    </Button>
                </div>
            </div>
            {showModalChangePassword &&
                <ModalChangePassword
                    onSubmit={onChangePassword}
                    closeModal={() => setShowModalChangePassword(false)}
                />
            }
            {showModalChangeEmail &&
                <ModalChangeEmail
                    waitCode={waitCode}
                    returnStep={onReturnChange}
                    onSubmit={onChangeEmail}
                    closeModal={() => setShowModalChangeEmail(false)}
                />
            }
        </div>
    )
}

export default Profile
